import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.all.farm');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-farm-all-farm',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.all.farm/view.scss */
/* src/app/portal.farm.all.farm/view.scss: no such file or directory */`],
})
export class PortalFarmAllFarmComponent implements OnInit {

    public count1 = 0;
    public count2 = 0;

    public loading = false;

    constructor(@Inject( Service    )         public service: Service    ) { }

    public async ngOnInit() {
        await this.service.init();

        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('farm_status');

        if (code === 200) {
            this.count1 = data.count1;
            this.count2 = data.count2;
        }

        this.loading = false;
        await this.service.render();
    }
}

export default PortalFarmAllFarmComponent;